<template>
    <div>
        <Head><title>System Settings</title></Head>
        <h1 class="mb-8 text-3xl font-bold">System Setting</h1>
    </div>
    <div class="grid">
        <ul class="flex flex-col">
            <li class="flex items-center py-3">
                <span class="ml-auto">Mpesa Key</span>
                <input type="password"
                       class=" ml-auto bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                       placeholder="•••••••••" readonly>
                <InertiaLink class="btn-indigo ml-3 p-2.5" href="">
                    <span class="hidden md:inline"> Change Key&nbsp;</span>
                </InertiaLink>
            </li>
            <li class="flex items-center py-3">
                <span>Mpesa Secret</span>
                <input type="password"
                       class=" ml-auto bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                       placeholder="•••••••••" readonly>
                <InertiaLink class="btn-indigo ml-3 p-2.5" href="">
                    <span class="hidden md:inline"> Change Key&nbsp;</span>
                </InertiaLink>

            </li>
            <li class="flex items-center py-3">
                <span>PayPal Key</span>
                <input type="password"
                       class="ml-auto bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                       placeholder="•••••••••" readonly>
                <InertiaLink class="btn-indigo ml-3 p-2.5" href="">
                    <span class="hidden md:inline"> Change Key&nbsp;</span>
                </InertiaLink>
            </li>
            <li class="flex items-center py-3">
                <span>PayPal Secret</span>
                <input type="password"
                       class=" ml-auto bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                       placeholder="•••••••••" readonly>
                <InertiaLink class="btn-indigo ml-3 p-2.5" href="">
                    <span class="hidden md:inline"> Change Key&nbsp;</span>
                </InertiaLink>
            </li>
            <li class="flex items-center py-3">
                <span>Support Phone</span>
                <input type="text" id="support_phone" v-model="keys.support_phone"
                       class=" ml-auto bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                       readonly>
                <InertiaLink class="btn-indigo ml-3 p-2.5" href="">
                    <span class="hidden md:inline"> Change Phone&nbsp;</span>
                </InertiaLink>
            </li>
            <li class="flex items-center py-3">
                <span>Support Email</span>
                <input type="text" id="support_phone" v-model="keys.support_email"
                       class=" ml-auto bg-gray-50 border border-gray-300 text-gray-900 tex t-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                       readonly>
                <InertiaLink class="btn-indigo ml-3 p-2.5" href="">
                    <span class="hidden md:inline"> Change Email&nbsp;</span>
                </InertiaLink>
            </li>
            <li class="flex items-center py-3">
                <span>Support Calender Link</span>
                <input type="text" id="support_phone" v-model="keys.support_calender_link"
                       class=" ml-auto bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                       readonly>
                <InertiaLink class="btn-indigo ml-3 p-2.5" href="">
                    <span class="hidden md:inline"> Change Link&nbsp;</span>
                </InertiaLink>
            </li>
        </ul>
    </div>
</template>

<script>
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'

export default {

    layout: Layout,
    props: {
        keys: Object,

        data() {
        },
        watch: {
            form: {
                deep: true,
                handler: throttle(function () {
                    this.$inertia.get('/settings', pickBy(this.form), {preserveState: true})
                }, 150),
            },
        },
    }
}
</script>
